import { Box, Typography } from '@mui/material';

export type AboutSectionPartPosition = 'left' | 'right';

type AboutSectionPartProps = {
  image: string;
  title: string;
  description: string;
  position?: AboutSectionPartPosition;
};

const Video = ({ videoUrl }: { videoUrl: string }) => (
  <Box
    sx={{
      width: '50%',
      height: 400,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 2,
      boxShadow: 2,
      background: '#000',
    }}
  >
    <video
      autoPlay
      loop
      muted
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        //transform: 'scale(0.1)', // Zoom in for horizontal crop
      }}
    >
      <source src={videoUrl} type="video/mp4" />
    </video>
  </Box>
);

export const AboutSectionPart = ({ image: content, title, description, position = 'left' }: AboutSectionPartProps) => (
  <Box display="flex" flexDirection={position === 'left' ? 'row' : 'row-reverse'} gap={10}>

    <Box flex='1' flexBasis='50%' justifyContent={'center'} display='flex'>
      {/* <img src={content} style={styles.sectionImage} /> */}
      <Video videoUrl={content} />
    </Box>

    <Box flex='1' flexBasis='50%' sx={{ p: 6, display: 'flex' }} justifyContent={'center'}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 600 }}>
        <Typography sx={styles.sectionTitle} gutterBottom>{title}</Typography>
        <Typography sx={styles.sectionBody} gutterBottom>{description}</Typography>
      </Box>
    </Box>
  </Box>
);

const styles = {
  sectionImage: {
    height: '100%',
    maxHeight: 400,
    //maxWidth: 1024,
    objectFit: 'cover' as 'cover',
    objectPosition: 'center',
  },
  sectionTitle: {
    typography: 'h5',
    textAlign: 'center',
  },
  sectionBody: {
    typography: 'body1',
    textAlign: 'center',
  },
};
